import { Heart, HomeIcon, Map, MapIcon, User } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router";
import { useLocationContext } from "../../../context/LocationContext";

const PageFooter = (props) => {
    // This is silly, it should be passed in via props
    const navigate = useNavigate();
    const location = useLocation();

    const { address, coords } = useLocationContext();

    if (!address || !coords) {
        return <></>; // Don't render footer if no location is set
    }
    const routesToShow = [
        '/',
        '/dashboard',
        '/favorites',
        '/map',
        '/favorites',
        '/category/',
        '/order/',
        '/order-cancelled'
    ]



    const shouldShow = routesToShow.some(route => {
        if (route === '/') {
            return location.pathname === '/';
        }
        return location.pathname.startsWith(route);
    });
    if (!shouldShow) {
        return <></>; // Don't render footer if not on a specified route
    }

    const links = [
        { to: '/', icon: HomeIcon, label: 'Shop' },
        { to: '/map', icon: MapIcon, label: 'Map' },
        { to: '/favorites', icon: Heart, label: 'Favourites' },
        { to: '/dashboard', icon: User, label: 'Profile', additionalPrefix: "/order/" },
    ];

    return (
        <footer className="fixed z-50 bottom-0 border-t-gray-200 border-t-2 w-full bg-white">
            <div className="flex justify-between items-center px-8 py-3 pb-4 w-full max-w-[400px] mx-auto">
                {links.map(({ to, icon: Icon, label, additionalPrefix }) => {
                    const isActive = location.pathname === to || (to != "/" && additionalPrefix && location.pathname.startsWith(additionalPrefix));
                    return (
                        <div key={to} className="w-1/5">
                            <Link

                                to={to}
                                className={`flex flex-col items-center text-sm ${isActive ? "opacity-100" : "opacity-50"}`}
                            >
                                <Icon className="w-6 h-6" />
                                <span className={`mt-1 text-sm text-black ${isActive ? "bg-gg-green rounded-lg px-2" : ""}`}>{label}</span>
                            </Link>
                        </div>
                    )
                })}
            </div>
        </footer>

    )

}

export default PageFooter;